"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelFetch = exports.showCartInfo = exports.fetchFilesFailure = exports.fetchFilesSuccess = exports.fetchFiles = exports.deserializeFailure = exports.deserializeSuccess = exports.deserialize = exports.serializeFailure = exports.serializeSuccess = exports.serialize = exports.toggleCart = exports.clearAll = exports.removeItems = exports.addItems = exports.fetchItemsFailure = exports.fetchItemsSuccess = exports.fetchItems = void 0;
const ActionTypes = require("../actionTypes/cart");
function fetchItems(rootId) {
    return {
        type: ActionTypes.FETCH_ITEMS_REQUEST,
        rootId
    };
}
exports.fetchItems = fetchItems;
function fetchItemsSuccess(data) {
    return {
        type: ActionTypes.FETCH_ITEMS_SUCCESS,
        result: {
            data
        }
    };
}
exports.fetchItemsSuccess = fetchItemsSuccess;
function fetchItemsFailure(error) {
    return {
        type: ActionTypes.FETCH_ITEMS_FAILURE,
        error
    };
}
exports.fetchItemsFailure = fetchItemsFailure;
function addItems(items, rootId) {
    return {
        type: ActionTypes.ADD_ITEMS,
        data: {
            items
        },
        rootId
    };
}
exports.addItems = addItems;
function removeItems(ids, rootId) {
    return {
        type: ActionTypes.REMOVE_ITEMS,
        data: {
            ids
        },
        rootId
    };
}
exports.removeItems = removeItems;
function clearAll(rootId) {
    return {
        type: ActionTypes.CLEAR_ALL,
        rootId
    };
}
exports.clearAll = clearAll;
function toggleCart() {
    return {
        type: ActionTypes.TOGGLE_CART
    };
}
exports.toggleCart = toggleCart;
function serialize(rootId) {
    return {
        type: ActionTypes.SERIALIZE_REQUEST,
        rootId
    };
}
exports.serialize = serialize;
function serializeSuccess() {
    return {
        type: ActionTypes.SERIALIZE_SUCCESS
    };
}
exports.serializeSuccess = serializeSuccess;
function serializeFailure(error) {
    return {
        type: ActionTypes.SERIALIZE_FAILURE,
        error
    };
}
exports.serializeFailure = serializeFailure;
function deserialize(rootId) {
    return {
        type: ActionTypes.DESERIALIZE_REQUEST,
        rootId
    };
}
exports.deserialize = deserialize;
function deserializeSuccess(data) {
    return {
        type: ActionTypes.DESERIALIZE_SUCCESS,
        result: {
            data: {
                data
            }
        }
    };
}
exports.deserializeSuccess = deserializeSuccess;
function deserializeFailure(error) {
    return {
        type: ActionTypes.DESERIALIZE_FAILURE,
        error
    };
}
exports.deserializeFailure = deserializeFailure;
function fetchFiles(files) {
    return {
        type: ActionTypes.FETCH_FILES,
        payload: {
            files
        }
    };
}
exports.fetchFiles = fetchFiles;
function fetchFilesSuccess(files) {
    return {
        type: ActionTypes.FETCH_FILES_SUCCESS,
        payload: {
            files
        }
    };
}
exports.fetchFilesSuccess = fetchFilesSuccess;
function fetchFilesFailure(error) {
    return {
        type: ActionTypes.FETCH_FILES_FAILURE,
        error
    };
}
exports.fetchFilesFailure = fetchFilesFailure;
const showCartInfo = (payload) => {
    return {
        type: ActionTypes.SHOW_CART_INFO,
        payload
    };
};
exports.showCartInfo = showCartInfo;
function cancelFetch() {
    return {
        type: ActionTypes.CANCEL_FETCH
    };
}
exports.cancelFetch = cancelFetch;
//# sourceMappingURL=cart.js.map